// Widget Registry
// Import all widgets here to register them

import StatsWidget from './StatsWidget';
import RevenueWidget from './RevenueWidget';
import EntriesWidget from './EntriesWidget';
import BackupWidget from './BackupWidget';
import ShellyWidget from './ShellyWidget';
import TeamWidget from './TeamWidget';
import GrafanaWidget from './GrafanaWidget';
import AnalyticsWidget from './AnalyticsWidget';
import WidgetWrapper from './WidgetWrapper';

export const widgetRegistry = {
  'stats': {
    component: StatsWidget,
    title: '📊 Overview',
    defaultSize: { cols: 12 },
    category: 'business'
  },
  'revenue': {
    component: RevenueWidget,
    title: '💰 Revenue',
    defaultSize: { cols: 6 },
    category: 'business'
  },
  'recent-entries': {
    component: EntriesWidget,
    title: 'Recent Time Entries',
    defaultSize: { cols: 6 },
    category: 'business'
  },
  'backup': {
    component: BackupWidget,
    title: '💾 Backups',
    defaultSize: { cols: 4 },
    category: 'infrastructure'
  },
  'shelly': {
    component: ShellyWidget,
    title: '🌡️ Datacenter Temp',
    defaultSize: { cols: 4 },
    category: 'infrastructure'
  },
  'team': {
    component: TeamWidget,
    title: '👥 Team Activity',
    defaultSize: { cols: 4 },
    category: 'business'
  },
  'grafana': {
    component: GrafanaWidget,
    title: '📈 Grafana Dashboards',
    defaultSize: { cols: 6 },
    category: 'infrastructure'
  },
  'analytics': {
    component: AnalyticsWidget,
    title: '📊 Google Analytics',
    defaultSize: { cols: 6 },
    category: 'business'
  }
};

export const getWidget = (id) => widgetRegistry[id];

export const getWidgetsByCategory = (cat) => 
  Object.entries(widgetRegistry).filter(([_, w]) => w.category === cat);

export { WidgetWrapper };
export default widgetRegistry;